import { styled } from 'styled-components';
import '../../../../../../../utils/styles/reset/resetBox.js';
import { resetButton } from '../../../../../../../utils/styles/reset/resetButton.js';
import '../../../../../../../utils/styles/reset/resetInput.js';
import '../../../../../../../utils/styles/reset/resetUl.js';
import '../../../../../../../utils/styles/responsive/responsive.js';
import '../../../../../../../utils/styles/size/absoluteFullsize.js';

const Button = styled.button.attrs({ type: "button" })`
  ${resetButton}

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  outline: none;
  color: var(--color-white);

  svg {
    width: 11px;
    height: auto;
    margin-right: 12px;
  }
`;
const Text = styled.span`
  font-family: 'Roobert';
  font-size: 16px;
  font-style: normal;
  font-weight: 650;
  line-height: normal;
`;

export { Button, Text };
//# sourceMappingURL=styles.js.map
